/**
 * Base abstract component for all components,
 * includes AppService and ConfDataService services.
 *
 * @Author: Jon Lucas
 * @Date:   2017-09-22T16:27:33+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-26T14:47:26+02:00
 */

import { OnInit, OnDestroy } from "@angular/core";

import { AppService } from "../app.service";
import { ConfDataService } from "../conf-data.service";

import { ServiceLocator } from "../service-locator";
import {ApiUtils} from "../util/ApiUtils";

export class AbstractComponent implements OnInit, OnDestroy {

    public readonly TAG: string = "[AbstractComponent]";

    protected appService: AppService;
    protected confDataService: ConfDataService;

    private _lang: string;

    constructor() {
        this.appService = ServiceLocator.injector.get(AppService);
        this.confDataService = ServiceLocator.injector.get(ConfDataService);
        this.initBindedEvents();
    }

    public set lang(pValue: string) {

        if (this._lang === pValue)    { return; }

        this._lang = pValue;

        this.onLangChanged();
    }

    public get lang(): string {
        return this._lang;
    }

    /**
     * Override this method if you need to detect
     * language changes not catch by ngOnChange.
     * (ex: lang changes detected by route params, like in the BuildingCustomizationComponent)
     */
    public onLangChanged(): void {
        console.log(this.TAG, "onLangChanged()");
    }

    protected initBindedEvents(): void
    {

    }

    public addListeners(): void
    {
        this.removeListeners();
    }

    public removeListeners(): void
    {

    }

    public getData(): void {
        // console.log(this.TAG, "getData()");
        // this.appService.getDatas().then(types => this.types = types);
    }

    public ngOnInit(): void {
        this.getData();
    }

    public ngOnDestroy(): void
    {
        this.removeListeners();
    }

}



// WEBPACK FOOTER //
// ./src/app/abstract-component/abstract.component.ts